import * as React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { Routes, Route } from 'react-router';
import { HistoryRouter } from 'redux-first-history/rr6';

import { configureStore, createHistory } from 'app/store/modules';
import { SettingsContainer } from 'app/pages/settings';
import { DashboardContainer } from 'app/pages/dashboard';
import { OrdersContainer } from 'app/pages/orders';
import { NotFoundComponent } from 'app/pages/notFound';
import { OnboardingContainer } from 'app/pages/onboarding';
import { DefaultLayout } from 'app/layouts/default';
import { HomeContainer } from 'app/pages/home';
import { LoginContainer } from 'app/pages/login';

import 'react-vis/dist/style.css';
import 'app/assets/css/reset.css';
import 'app/assets/css/index.css';

// the settings page on its own (the dashboard also opens settings in its sidebar, and closes them when done);
// here Update saves and Cancel does nothing, as before
const SettingsPage = () => <SettingsContainer onSettingsEnd={() => undefined} />;

const store = configureStore();
const history = createHistory(store);

// each page also matches the paths below it (/dashboard/anything), as with react-router 5's non-exact routes
const Main = () => (
  <Provider store={store}>
    <HistoryRouter history={history}>
      <Routes>
        <Route path="/" element={<HomeContainer />} />
        <Route path="/dashboard/*" element={<DefaultLayout component={DashboardContainer} />} />
        <Route path="/settings/*" element={<DefaultLayout component={SettingsPage} />} />
        <Route path="/orders/*" element={<DefaultLayout component={OrdersContainer} />} />
        <Route path="/onboarding/*" element={<DefaultLayout component={OnboardingContainer} />} />
        <Route path="/login/*" element={<DefaultLayout component={LoginContainer} />} />
        <Route path="/register/*" element={<DefaultLayout component={LoginContainer} />} />
        <Route path="/forgot_password/*" element={<DefaultLayout component={LoginContainer} />} />
        <Route path="*" element={<DefaultLayout component={NotFoundComponent} />} />
      </Routes>
    </HistoryRouter>
  </Provider>
);

createRoot(document.getElementById('app') as HTMLElement).render(<Main />);

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    void navigator.serviceWorker.register('/service-worker.js');
  });
}
